import React, { useState, Component, Fragment } from "react";
import { render } from 'react-dom';
import { Navigationmenu } from "../components";
import circulargridimage from "../gallery/gridloader.gif";
import { ExportExcel } from "./ExportExcel";
// import utils from '../utils'
import Moment from 'moment';

import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  MuiEditableLabel,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Popover,
  Dialog,
  Tabs,
  Tab,
  DialogActions,
  withStyles,
  TableFooter,
} from "@material-ui/core";

import {
  ALTERNATEROW_BACKGROUND_COLOR,
  BLUE_COLOR,
  LIGHTGRAY_COLOR,
  MODIFIEDBLACK,
  PINK_COLOR,
  PROTECT_GREEN,
  RED_COLOR,
  VIBRANT_GREEN,
} from "../constants";

import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from "../APICall";
import { parse } from "query-string";

const StyledTabs = withStyles(
  {
    indicator: {
      display: "flex",
      backgroundColor: "white",
      height: 3,
    },
  },
  { index: 1 }
)((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles(
  (theme) => (
    {
      root: {
        textTransform: "none",
        color: "white",
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        "&:focus": {
          opacity: 1,
        },
      },
    },
    { index: 1 }
  )
)((props) => <Tab disableRipple {...props} />);

export default class ABDPage extends Component {
  state = {
    tablebuffer: [],
    pageSize: 10,
    showPager: false,
    SOURCE: "",
    IsWindowsAuth: "",
    SNAME: "",
    SNAMElabel: "",
    DOB: "",
    DBUserName: "",
    DBPassword: "",
    DBSource: "",
    DBProvider: "",
    test: false,
    isloading: false,
    pagesObj: [],
    selectedUser: "",
    newOBJ: [],
    serialNumber: "",
    selectedPass: "",
    ismandatory: false,
    pageloadingdata: 0,
    redirect: false,
    direction: "SearchPage",
    showModal: false,
    tablebuffer: [],
    pages: 0,
    current: 1,
    records: 0,
    pageSize: 10,
    showPager: false,
    SearchButtonDisable: false,
    ExportButtonDisabled: true,
    RefreshButtonDisable: false,
    SOURCE: "",
    FNAME: "",
    SNAME: "",
    ACCOUNTDETAILNO: "",
    SelectedAgentType: "",
    SelectedGroupValue: "",
    SelectedPeriod: "",
    ListType: [],
    PeriodDetail: [],
    pagesObj: [],
    SavebuttonDisable: false,
    searchbuttonbackcolor: BLUE_COLOR,
    exportbuttonbackcolor: LIGHTGRAY_COLOR,
    clearbuttonbackcolor: BLUE_COLOR,
    isloading: false,
    isadmin: false,
    isadminSwitch: false,
    ShowOccupation: true,
    diableRadio: true,
    BeneFitPayble: false,
    ChckOnboarding: true,
    disableSelectedINTROType: false,
    disableSelectedpaymentType: false,
    disableBenef: false,
    Nainpayment: true,
    NANSourceOfFund: true,
    NANSourceOfIntroduction: true,
    NANBenef: true,
    clearresult: true,
  };

  handleChange = (event) => {
    this.setState({ isadmin: event.target.checked });
  };
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleLeavePage);
  }

  handleLeavePage(e) {
    const confirmationMessage = "My message";
    e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
    return confirmationMessage; // Gecko, WebKit, Chrome <34
  }

  pageChange(number) {
    this.state.current = number;
    var data = this.state.alldata.slice(
      this.state.current * this.state.pageSize,
      (this.state.current + 1) * this.state.pageSize
    );
    this.setState({ tablebuffer: data });

    this.state.pagesObj = [];
    if (this.state.pages < 10) {
      for (var i = 0; i < this.state.pages; i++) this.state.pagesObj.push(i);
    } else {
      var min = this.state.current - 5;
      var max = this.state.current + 5;
      if (min < 0) min = 0;
      if (max > this.state.pages) max = this.state.pages;
      if (max - min > 10) {
        min = this.state.current - 5;
        max = this.state.current + 5;
      }
      if (min > 0) this.state.pagesObj.push(0);
      for (var i = min; i < max; i++) this.state.pagesObj.push(i);
      if (max < this.state.pages - 1)
        this.state.pagesObj.push(this.state.pages - 1);
    }
  }
  renderpages() {
    this.state.records = this.state.alldata.length;
    this.state.pages = parseInt(this.state.records / this.state.pageSize);
    if (this.state.records % this.state.pageSize > 0) this.state.pages++;
    this.state.showPager = this.state.pages > 1;
    this.pageChange(0);
  }

  clearScreen() {
    var r = window.confirm("Do you want to Clear ?");
    if (r == true) {
      this.setState({
        SNAME: "",
        FNAME: "",
        isloading: false,
        SearchButtonDisable: false,
        searchbuttonbackcolor: BLUE_COLOR,
        tablebuffer: [],
        pagesObj: [],
        showPager: false,
        SelectedAgentType: "",
        SelectedPeriod: "",
        ExportButtonDisabled: true,
        exportbuttonbackcolor: LIGHTGRAY_COLOR,
      });
    }
  }

  padValue = (value) => {
    return value < 10 ? "0" + value : value;
  };
  convertDateStringintoYYYYMMDD(date) {

    if (date != "")
      return date.slice(0, 4) + "-" + date.slice(5, 7) + "-" + date.slice(8, 10);
    // return date.slice(0, 4) + "-" + date.slice(5, 7) + "-" + date.slice(8, 10);
    else return date;
  }
  convertToDecimal(number) {
    var d = Number(number)
    return d
  }

  handletextChange(e, key) {
    this.setState({ key: e.target.value });
    this.state[key] = e.target.value;
  }

  refi(e) {
    if (e == "SEARCHSPS") {
      this.refinitsearchfun(e);
    }
  }

  isEven(n) {
    return n % 2 == 0;
  }

  refinitsearchfun(e) {
    var listGroupValue = "";

    if (this.state.SelectedAgentType == "ALL") {
      this.setState({
        SelectedGroupValue: "",
      });

      this.GetSalesDetails();
    } else if (this.state.SelectedAgentType == "") {
      alert("No Data Found")
    } else {
      listGroupValue = this.state.SelectedAgentType;

      var data50 = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "GETAGENTTYPEGROUPVALUE",
        MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
        body: {
          listType: listGroupValue || "",
        },
      };
      fnPostapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "PostApiMiddleWare",
        data50,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response) => {
          var data55 = response.data[0][0];
          if (data55 != undefined) {
            this.setState({
              SelectedGroupValue: data55.GROUP_VALUES,
            });
            this.GetSalesDetails();
          } else {
            alert("No Data Found");
          }
        })
        .catch((e) => console.log(e));
    }
  }

  GetSalesDetails() {
    this.setState({ alldata: [] });
    this.state.pagesObj = [];
    this.state.newOBJ = [];

    var Period = this.state.SelectedPeriod;

    var data10 = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETAGEING",
      MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
      body: {
        PeriodNumber: Period || "",
      },
    };
    this.state.isloading = true;
    fnPostapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "PostApiMiddleWare",
      data10,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        var data11 = response.data[0][0];
        if (data11 == undefined) {
        } else {
          var ageing = data11.AGEING;
        }
        var data2 = {
          MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
          MAPINAME: "GETSALESDETAILS",
          MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
          body: {
            AgeingNumber: ageing || "",
            AgentCategory: this.state.SelectedGroupValue || "",
          },
        };
        fnPostapiResponse(
          process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
          "PostApiMiddleWare",
          data2,
          process.env.REACT_APP_PORT_MIDDLEWARE
        )
          .then((response) => {
            this.setState({ newOBJ: response.data[0] });
            // this.setState({ newOBJ: response1.data.Message })
            console.log("New OBJ => ", response.data);
            // console.log("After Merge Obj => ", this.state.newOBJ.concat(response.data.SearchResultMSG))
            if (
              this.state.newOBJ == null ||
              this.state.newOBJ == "null" ||
              this.state.newOBJ == "" ||
              this.state.newOBJ == undefined
            ) {
              alert("No Data Found");
              this.setState({
                alldata: response.data.recordset,
                isloading: false,
                SearchButtonDisable: false,
                searchbuttonbackcolor: BLUE_COLOR,
                ExportButtonDisabled: true,
                exportbuttonbackcolor: LIGHTGRAY_COLOR,
              });
            } else {
              this.setState({ serialNumber: response.data[0][0].SERIALNUM });

              var rowObj = response.data;
              var newdata = rowObj[0];

              console.log(this.state.newOBJ[0]["DATE_1"])

              for (var i = 0; i < this.state.newOBJ.length; i++) {
                // console.log(this.state.newOBJ[i]["DATE_1"])
                this.state.newOBJ[i]["DATE_1"] = this.convertDateStringintoYYYYMMDD(
                  this.state.newOBJ[i]["DATE_1"])

                this.state.newOBJ[i]['AGE_1'] = Number(newdata[i]["AGE_1"])
                this.state.newOBJ[i]['AGE_2'] = Number(newdata[i]["AGE_2"])
                this.state.newOBJ[i]['AGE_3'] = Number(newdata[i]["AGE_3"])
                this.state.newOBJ[i]['AGE_4'] = Number(newdata[i]["AGE_4"])
                this.state.newOBJ[i]['AGE_5'] = Number(newdata[i]["AGE_5"])
                this.state.newOBJ[i]['AGE_6'] = Number(newdata[i]["AGE_6"])
                this.state.newOBJ[i]['AGE_7'] = Number(newdata[i]["AGE_7"])
                this.state.newOBJ[i]['NUM_PREMS_DUE'] = Number(newdata[i]["NUM_PREMS_DUE"])
                this.state.newOBJ[i]['BAL'] = Number(newdata[i]["BAL"])

              }
            }
            if (this.state.newOBJ.length > 100) {
              var r = window.confirm(
                "Many Records matched search Criteria. Ok to Proceed or Cancel to redefine Search Criteria"
              );
              if (r) {
                // this.searchandsave(
                //   data,
                //   response.data.recordset.length,
                // );
                var rowObj = response.data;
                var newdata = rowObj[0];

                console.log(this.state.newOBJ[0]["DATE_1"])

                // for (var i = 0; i < this.state.newOBJ.length; i++) {
                //   // console.log(this.state.newOBJ[i]["DATE_1"])
                //   this.state.newOBJ[i]["DATE_1"] = this.convertDateStringintoYYYYMMDD(
                //     this.state.newOBJ[i]["DATE_1"]
                //   );
                // }KC

                this.setState({
                  isloading: false,
                  alldata: this.state.newOBJ,
                });
                this.renderpages();
              } else {
                this.setState({ alldata: [], isloading: false });
                this.renderpages();
              }
            } else {
              // this.searchandsave(
              //   data,
              //   response.data.recordset.length
              // );

              this.setState({
                alldata: this.state.newOBJ,
                isloading: false,
              });
            }
            this.renderpages();
            // if (
            //   this.state.newOBJ.length == 0
            // )
            //   alert("No data found!");
          })
          .catch((e) => console.log(e));
      })
      .catch((e) => console.log(e));

    this.setState({
      SearchButtonDisable: true,
      searchbuttonbackcolor: LIGHTGRAY_COLOR,
      ExportButtonDisabled: false,
      exportbuttonbackcolor: BLUE_COLOR,
    });
  }

  componentDidMount() {
    sessionStorage.setItem("isRBMRedirectfromAML", "")
    var data = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETPERIOD",
      MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
      body: "",
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        var data = response.data;
        if (data != undefined) {
          this.setState({
            PeriodDetail: data[0],
          });
        } else {
          alert(data);
        }
      })
      .catch((e) => console.log(e));

    var data20 = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETAGENTTYPE",
      MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
      body: "",
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data20,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        var data25 = response.data;
        if (data25 != undefined) {
          this.setState({
            ListType: data25[0],
          });
        } else {
          alert(data);
        }
      })
      .catch((e) => console.log(e));
  }

  render() {
    return (
      <Fragment>
        <Navigationmenu selectedMenu={"SPSPage"} />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ marginTop: 35 }}
        >
          <Paper
            elevation={2}
            style={{ minHeight: 100, width: "90%", borderRadius: 6 }}
          >
            <form>
              <Box display="flex" alignItems="center" justifyContent="center">
                <div style={{ minHeight: 100, width: "98%", borderRadius: 6 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={11}>
                      <div
                        style={{
                          display: "flex",
                          marginBottom: 20,
                          marginTop: 60,
                        }}
                      >
                        <Typography
                          style={{
                            borderWidth: 0,
                            color: BLUE_COLOR,
                            textTransform: "uppercase",
                            fontFamily: "Globerbold",
                            fontSize: 30,
                            paddingLeft: 10,
                          }}
                        >
                          DEBTORS LIST
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    style={{ width: "calc(100% + 200px)" }}
                  >
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      AGENT TYPE
                    </Grid>
                    <Grid item xs={5}>
                      <Select
                        fullWidth
                        InputProps={{ readOnly: true }}
                        variant={"outlined"}
                        value={this.state.SelectedAgentType}
                        onChange={(e) =>
                          this.setState({ SelectedAgentType: e.target.value })
                        }
                      >
                        {/* {this.state.ListType.map((team) => (
                          <MenuItem value={team.DESC50}>{team.DESC50}</MenuItem>
                        ))} */}
                        {/* <MenuItem value="ALL">ALL</MenuItem> */}
                        <MenuItem value="REGIONAL SALES">REGIONAL SALES</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    style={{ width: "calc(100% + 200px)" }}
                  >
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      PERIOD
                    </Grid>
                    <Grid item xs={5}>
                      <Select
                        fullWidth
                        InputProps={{ readOnly: true }}
                        variant={"outlined"}
                        value={this.state.SelectedPeriod}
                        onChange={(e) =>
                          this.setState({ SelectedPeriod: e.target.value })
                        }
                      >
                        {this.state.PeriodDetail.map((team) => (
                          <MenuItem value={team.PERIOD}>{team.PERIOD}</MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Button
                      variant={"text"}
                      disabled={this.state.SearchButtonDisable}
                      onClick={(e) => this.refi("SEARCHSPS")}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.searchbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "8px",
                        marginLeft: "185px",
                      }}
                    >
                      Search
                    </Button>
                    <Button
                      variant={"text"}
                      onClick={(e) => this.clearScreen()}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.clearbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "7px",
                      }}
                    >
                      Clear
                    </Button>
                    <ExportExcel
                      csvData={this.state.newOBJ}
                      disabled={this.state.ExportButtonDisabled}
                      backcolor={this.state.exportbuttonbackcolor}
                      fileName={
                        this.state.SelectedPeriod +
                        "_" +
                        this.state.serialNumber +
                        "_" +
                        this.state.SelectedAgentType +
                        ""
                      }
                    />
                  </Grid>
                  <br></br>
                  <br></br>
                  <br></br>
                  <Grid item xs>
                    <TableContainer>
                      <Table aria-label="table">
                        <TableHead
                          style={{ backgroundColor: "rgba(241,241,241,1.0)" }}
                        >
                          <TableRow>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              SERIALNUM
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              RECORD_STAT
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              ST_AGENT_CODE
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              POLICY_NO
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              DATE_1
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              PREM_PAY_FREQ
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              NUM_PREMS_DUE
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_1
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_2
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_3
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_4
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_5
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_6
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGE_7
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              BAL
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              TITLE
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              FORENAMES
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              SURNAME
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              AGENT_CAT
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              TELEPHONE_MOBILE
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              TELEPHONE_HOME
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              TELEPHONE_OFFICE
                            </TableCell>

                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "350px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              ADDRESS
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              DATE_OF_BIRTH
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              SALREGION
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {!this.state.isloading ? (
                            this.state.tablebuffer.map((obj, index) => {
                              var rowbackgroundColor = "white";
                              if (this.isEven(index)) {
                                rowbackgroundColor =
                                  ALTERNATEROW_BACKGROUND_COLOR;
                              }

                              if (
                                this.state.ishovered &&
                                this.state.hoverindex == index
                              ) {
                                rowbackgroundColor = LIGHTGRAY_COLOR;
                              }
                              if (obj != undefined) {
                                return (
                                  <TableRow
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.setState({ showDialog: true })
                                    }
                                    key={index}
                                    hover={true}
                                    onMouseOut={() =>
                                      this.setState({ ishovered: false })
                                    }
                                    onMouseEnter={() =>
                                      this.setState({
                                        hoverindex: index,
                                        ishovered: true,
                                      })
                                    }
                                  >
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.SERIALNUM}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["RECORD_STAT"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.ST_AGENT_CODE}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["POLICY_NO"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {/* {utils.getDateAsYYYYMMDD(parseFloat(obj["DATE_1"]))}
                                      {console.log(utils.getDateAsYYYYMMDD(obj["DATE_1"]))} */}
                                      {/* {utils.getDateAsYYYYMMDD(parseFloat(obj["DATE_1"]))} */}
                                      {/* {utils.getDateAsYYYYMMDD(obj["DATE_1"])} */}
                                      {obj["DATE_1"]}
                                      {/* {console.log(
                                        new Date(obj["DATE_1"])
                                      )} */}
                                      {/* {Moment(obj["DATE_1"]).format('YYYY-MM-DD')} */}
                                      {/* {parseFloat(obj["DATE_1"])} */}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["PREM_PAY_FREQ"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["NUM_PREMS_DUE"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGE_1"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {this.convertToDecimal(obj["AGE_2"])}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.AGE_3}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGE_4"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGE_5"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGE_6"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGE_7"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["BAL"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["TITLE"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["FORENAMES"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.SURNAME}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AGENT_CAT"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["TELEPHONE_MOBILE"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["TELEPHONE_HOME"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["TELEPHONE_OFFICE"]}
                                    </TableCell>

                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["ADDRESS"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["DATE_OF_BIRTH"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["SALREGION"]}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            })
                          ) : (
                            <td
                              style={{ marginLeft: "500px", height: "100px" }}
                            >
                              {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                              <img
                                style={{ width: "100px" }}
                                src={circulargridimage}
                                alt="circulargridimage"
                              />
                              ;
                            </td>
                          )}
                        </TableBody>
                      </Table>
                      <div
                        style={
                          this.state.showPager
                            ? {
                              height: 60,
                              marginLeft: "500px",
                              color: MODIFIEDBLACK,
                              fontSize: "15px",
                              textTransform: "uppercase",
                              fontFamily: "Globerbold",
                              wordBreak: "break-word",
                            }
                            : { display: "none" }
                        }
                      >
                        {this.state.pagesObj.map((obj, index) => {
                          return (
                            <span
                              style={{ padding: "0 3px", cursor: "pointer" }}
                            >
                              <a
                                style={
                                  this.state.current == obj
                                    ? {
                                      fontWeight: "bold",
                                      color: BLUE_COLOR,
                                      fontSize: "30px",
                                    }
                                    : {}
                                }
                                onClick={() => this.pageChange(obj)}
                              >
                                {obj + 1}
                              </a>
                            </span>
                          );
                        })}
                      </div>
                    </TableContainer>
                  </Grid>
                  <Divider style={{ marginTop: 15 }} />
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs></Grid>
                    <Grid item xs></Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 20 }}></Grid>
                </div>
              </Box>
            </form>
          </Paper>
        </Box>
      </Fragment>
    );
  }
}
